import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './stilus/demo.css';
import './stilus/sajat.css';
import { Alkalmazas } from './Alkalmazas.tsx';

const gyoker = document.getElementById('gyoker');
if (!gyoker) throw new Error('Nincs meg a "gyoker" elem az index.html-ben.');

createRoot(gyoker).render(
  <StrictMode>
    <Alkalmazas />
  </StrictMode>,
);

/**
 * A telepíthető alkalmazás háttérszála. (3.0 / 8.)
 *
 * Csak az éles csomagban indul el: fejlesztés közben csak zavarna, mert
 * a régi fájlokat adná vissza. Ha a böngésző nem ismeri, nem történik semmi
 * — a program ugyanúgy működik, csak nem lehet kitenni a kezdőlapra.
 */
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      /* ha nem sikerül, a program attól még megy */
    });
  });
}
